import { VatNatureType } from "../vat-nature-type";

export enum QuoteItemType {
  MEDICAL_SERVICE = "medical-service",
  DRUG_ASSIGNMENT = "drug-assignment",
  PARAPHARMACEUTICAL = "parapharmaceutical",
  PRODUCT_SALE = "product-sale"
}

export enum QuoteItemUnit {
  PACKAGE = "package",
  PIECE = "piece"
}

export interface QuoteItem {
  id?: string;
  number: string;
  name: string;
  description?: string;
  note?: string;
  rateTable?: {
    id: string;
    name: string;
  };
  quantity: number;
  maxQuantity?: number;

  unitPrice: number;
  maxUnitPrice?: number;

  discount: number;
  vat: number;
  vatNature?: VatNatureType;

  rateable: number;
  maxRateable?: number;

  vatTaxAmount: number;
  taxedTotal: number;
  adjustment: number;

  adjustedTotal: number;
  maxAdjustedTotal?: number;

  invoiceId?: string;
  invoiceNumber?: string;
  invoiceDate?: string;
  invoiceIsDraft?: boolean;

  //bookItemId?: string;
  bookItemIds?: string[];

  executedQuantity?: number;

  rateTableItemId: string;
  type: QuoteItemType;

  hasEnpav?: boolean;

  physiciansPercentage: number;

  unit?: QuoteItemUnit;
}

export type QuoteItemCreate = Omit<
  QuoteItem,
  | "id"
  | "createdAt"
  | "createdBy"
  | "invoiceId"
  | "invoiceNumber"
  | "invoiceDate"
  | "invoiceIsDraft"
>;
